import { render } from "./EditProductTranslationsTitleContent.vue?vue&type=template&id=1e593295&scoped=true&ts=true"
import script from "./EditProductTranslationsTitleContent.vue?vue&type=script&lang=ts"
export * from "./EditProductTranslationsTitleContent.vue?vue&type=script&lang=ts"

import "./EditProductTranslationsTitleContent.vue?vue&type=style&index=0&id=1e593295&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e593295"]])

export default __exports__